import { trigger, state, style, transition, animate } from '@angular/animations';

import { CommonModule, DatePipe } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogConfig, MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Roles } from '@app/modules/lps-member-login/models/commonmodel';
import { MemberInsurerRestService } from '@app/modules/lps-member-login/services/member-insurer-rest.service';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { ConfirmationmodalComponent } from '../../shared/components/confirmationmodal/confirmationmodal.component';
import { CustomDateAdapter } from '../../shared/pipes/custom-date-adapter';
import { MY_NATIVE_DATE_FORMATS } from '../../shared/pipes/date-format';
import { NotificationService } from '../../shared/services/notifications.service';
import { ConfirmationMode } from '../../shared/share';

@Component({
  selector: 'app-orgs-registration',
  standalone: true,
  imports: [MatFormFieldModule, ReactiveFormsModule, CommonModule, MatInputModule, MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule],
  templateUrl: './orgs-registration.component.html',
  styleUrl: './orgs-registration.component.scss',
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ],
  animations: [
    trigger('userCardAnimation', [
      state('unselected', style({
        transform: 'scale(1)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
        borderColor: 'transparent'
      })),
      state('selected', style({
        transform: 'scale(1.03)',
        borderColor: '#0075C9',
        background: 'linear-gradient(157deg, rgb(0 117 201 / 0%), rgb(102 174 224 / 20%))'
      })),
      transition('unselected <=> selected', [
        animate('250ms ease-in-out')
      ]),
    ])
  ]
})
export class OrgsRegistrationComponent {

  insurerForm: FormGroup;
  popupTitle = 'Add New Organisation';
  popupSubtitle = 'Enter the required information to register a new distributor admin.';
  isSubmitLoading: boolean = false;
  enumConfirmationMode = ConfirmationMode;
  userAccess = this.memberService.getUserAccess();
  enumRole = Roles;
  today = new Date();
  disable:boolean | undefined ;
  // tommorow=new Date();
  userRole = this.memberService.getLoginUserRole();

  @Input() isDismissable: boolean = false;
  imagePreviewUrl: string | ArrayBuffer | null = null;
  editedAdmin: any;

  insurerorg:any[]=[];
  admindistributorpayload = {
    "fcaReferenceNumber": "",
    "contactName": "",
    "email": '',
    "contactPhone": "",
    "address": "",
    "tradingName": "",
    "role": "",
    "websitrUrl": "",
    "activeStartDate": "",
    "activeEndDate": "",
    "addedBy": "",
    "imgLogoUrl": "",
    "adminInsurerIds": ""
  }

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<OrgsRegistrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog,
    private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService, private datepipe: DatePipe,
    private notificationService: NotificationService
  ) {

    if (data) {
      this.editedAdmin = data;
      console.log(this.editedAdmin)
    }

    this.insurerForm = this.fb.group({
      // FCA Reference Number (FRN) - Key Identifier
      // fcaReferenceNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
            fcaReferenceNumber: ['', ],


      // Trading name
      // tradingName: ['', Validators.required],
      tradingName: ['', ],


      // Logo (for UI) - already exists as imgLogoUrl
      imgLogoUrl: ['12121',],

      // Address
      address: ['', Validators.required],

      // Website URL
      websiteUrl: ['', [Validators.required, Validators.pattern(/^https?:\/\/.+/)]],

      // Key contact info
      contactPerson: ['', Validators.required],
      contactEmail: ['', [Validators.required, Validators.email]],
      // contactPhone: ['', [Validators.required, Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)]],
            contactPhone: ['', [Validators.required,]],

      orgType:['',Validators.required],

      // Active start and end dates
      activeStartDate: ['', Validators.required],
      activeEndDate: [''],

      // Legacy fields (keeping for backward compatibility)
      // firstName: ['',],
      // lastName: ['',],
      // dateOfBirth: [''],
      // gender: ['',],
      // email: ['', []],
      // phone: ['', []],
      // organisationName: [''],
      // role: ['ADMIN_INSURER'],
      // addedBy: ['SUPER_ADMIN'],
      mappedOrgIds:['133133',]
      // adminInsurerIds: ['', [Validators.required]]
    });

  

    // Add custom validation for end date
    this.insurerForm.get('activeEndDate')?.valueChanges.subscribe(endDate => {
      const startDate = this.insurerForm.get('activeStartDate')?.value;
      if (endDate && startDate && new Date(endDate) <= new Date(startDate)) {
        this.insurerForm.get('activeEndDate')?.setErrors({ invalidEndDate: true });
      } else {
        this.insurerForm.get('activeEndDate')?.setErrors(null);
      }
    });

  }

  ngOnInit() {

    if (this.editedAdmin) {
      this.insurerForm.patchValue({ tradingName: this.editedAdmin.tradingName })
       this.insurerForm.get('fcaReferenceNumber')?.disable();
       this.insurerForm.get('tradingName')?.disable();
      this.preFillForm(this.editedAdmin);
    } else {
      this.insurerForm.get('fcaReferenceNumber')?.enable();
      this.insurerForm.get('tradingName')?.enable();
    }
    this.getproviderOrg();
    this.getInsurerOrg();
    this.getDistributorOrg();
    if(this.insurerForm.valid){
      this.disable=false
    }
  }


  onFileDropped(event: Event) {
    event.preventDefault();
    const dragEvent = event as DragEvent;
    const files = dragEvent.dataTransfer ? dragEvent.dataTransfer.files : null;
    console.log(files);
    if (files && files.length > 0) {
      // this.handleFiles(files);
    }
  }

  preFillForm(data: any): void {
    if (data && this.insurerForm) {
      this.popupTitle = 'Edit Admin Distributor';
      this.popupSubtitle = 'Please provide the information below to edit admin Distributor.';
      console.log(data)
      this.insurerForm.patchValue({

        
        fcaReferenceNumber: this.data.fcaReferenceNumber || '',
        tradingName: this.data.tradingName || '',
        orgType: this.data.type || '', 
        address: this.data.address || '',
        websiteUrl: this.data.websiteUrl || '',
        contactPerson: this.data.contactPerson || '',
        contactEmail: this.data.email || '',
        contactPhone: this.data.contactPhone || '',
        //  data.dateOfBirth ? this.formatDate(data.dateOfBirth) : null
        activeStartDate: this.data.activeStartDate ? this.datepipe.transform(this.data.activeStartDate, 'yyyy-MM-dd') : null,

        activeEndDate: this.data.activeEndDate ?this.datepipe.transform(this.data.activeStartDate, 'yyyy-MM-dd') : null,

        imgLogoUrl: this.data.imgLogoUrl || ' ',
        // addedBy: this.data.lastupdatedby || '',
        mappedOrgIds:this.data.mappedOrgs?.orgId || ' ',
        // adminInsurerIds: this.data.insurers || '',



        // firstName: data.firstName || '',
        // lastName: data.lastName || '',
        // // dateOfBirth: data.dateOfBirth ? this.formatDate(data.dateOfBirth) : null,
        // gender: data.gender || '',
        // email: data.email || '',
        // phone: data.phone || '',
        // address: data.address || '',
        // organisationName: data.organisationName || '',
        // imgLogoUrl: data.imgLogoUrl || '',
        //  role: 'ADMIN_INSURER',
        //  // Static as per form definition
        // //  role: 'ADMIN_DISTRIBUTOR',
        // addedBy: data.createdby || 'SUPER_ADMIN'
      });

      if(data.type==='PROVIDER'){

        this.insurerForm.patchValue({
                  fcaReferenceNumber: this.data.mepNumber,


        })
      }
      else{
          this.insurerForm.patchValue({
                  fcaReferenceNumber: this.data.fcaReferenceNumber,


        })

      }
      if (data.insurers && Array.isArray(data.insurers)) {
        this.selectedProviderIds = [...data.insurers]; // Clone to avoid mutation
      }
    }
    console.log("afyer edit");
    console.log(this.insurerForm.valid)
    console.log(this.insurerForm.errors); // Check for form-level errors
console.log(this.insurerForm.controls); // Check individual control errors
    console.log( "the form is"  +this.insurerForm.valid)
    if(this.insurerForm.valid){
      this.disable=false
    }
    console.log(this.insurerForm.updateValueAndValidity());

  }

  fileUploaded: any;
  async onAssetImage(event: any) {
    const file = event.files[0];
    console.log(file);
    this.fileUploaded = file;
    this.previewImage(file);
    const url = await this.getfiles3Url(file);
    this.insurerForm.get('imgLogoUrl')?.patchValue(url.documentPath);
  }

  previewImageby(url: any) {
    this.imagePreviewUrl = url;
  }

  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imagePreviewUrl = e.target.result;
    };
    reader.readAsDataURL(file);
  }



  formatDate(dateStr: string): Date | null {
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        const [day, month, year] = parts.map(Number);
        return new Date(year, month - 1, day);
      }
      return null;
    }

  getfiles3Url(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      this.restService.uploadFile(file).subscribe(
        (response) => resolve(response),
        (error) => reject(error)
      );
    });
  }

  onFileInputClick() {
    console.log("clicked");

  }

  onsubmit() {
    console.log(this.insurerForm.valid)

     if(this.insurerForm.valid){

    const modifypayload=this.insurerForm.getRawValue();
            const newKey = this.editedAdmin?.id ? 'lastupdatedby' : 'createdby';
            const newKey1=this.insurerForm.get('orgType')?.value==='PROVIDER'?'mepNumber':'fcaReferenceNumber'
 console.log(this.insurerForm.valid)

    let payload = {
      // fcaReferenceNumber: modifypayload.fcaReferenceNumber,
      tradingName: modifypayload.tradingName,
      type: modifypayload.orgType,
      address: modifypayload.address,
      websiteUrl: modifypayload.websiteUrl,
      contactPerson: modifypayload.contactPerson,
      email: modifypayload.contactEmail,
      contactPhone: modifypayload.contactPhone,

      activeStartDate: modifypayload.activeStartDate ? this.datepipe.transform(modifypayload.activeStartDate, 'yyyy-MM-dd')
        : '',
      activeEndDate: modifypayload.activeEndDate ? this.datepipe.transform(modifypayload.activeEndDate, 'yyyy-MM-dd')
        : '',
      imgLogoUrl: modifypayload.imagePreviewUrl,
      // mappedOrgIds:["cd7bb239-ed26-4606-a80a-cc1b97a96f78"]

      // addedBy: this.memberService.getLoginUserId(),
      // adminInsurerIds: this.insurerForm?.value?.adminInsurerIds,

      //  "createdby": modifypayload.addedBy,
      // "lastupdatedby": this.memberService.getLoginUserId
    }
     

    
                  const newKey2 = this.insurerForm.get('orgType')?.value==='PROVIDER'? '' : 'mappedOrgIds';

      
      
     
    let modifypayloadvalues={[newKey]:this.memberService.getLoginUserId(),[newKey1]:modifypayload.fcaReferenceNumber,[newKey2]:modifypayload.mappedOrgIds,...payload};

    
   console.log("the modifypayload");
   console.log(modifypayloadvalues)


    const iseditable = this.editedAdmin?.id;
    console.log('the is editable is ' + iseditable);
    // const apicall = iseditable ? this.restService.editAdmins(payload, this.editedAdmin.id) : this.restService.addAdminDisturer(payload)

    console.log(this.insurerForm.get('activeStartDate')?.value)

    // if (this.insurerForm.valid &&  this.validateDateRange()) {
      this.isSubmitLoading = true;


      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '350px';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;

      const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
      dialogRef.componentInstance.title = 'Confirm';
      let message='';
      if(this.insurerForm.get('orgType')?.value==='INSURER'){
        message='Are You Sure You Wantr To Add Insurer Organisation'

      }
      else if(this.insurerForm.get('orgType')?.value==='PROVIDER'){
                message='Are You Sure You Wantr To Add Provider Organisation'

        
      }
      else if(this.insurerForm.get('orgType')?.value==='DISTRIBUTOR'){
                        message='Are You Sure You Wantr To Add Distributor Organisation'

      }
      dialogRef.componentInstance.mode = iseditable ? 'edit' : 'add';
      dialogRef.componentInstance.message = iseditable ? 'Are You Sure You Want To Edit Agent' : message;
      dialogRef.afterClosed().subscribe((res) => {

        console.log("the response " + res)
        if (res) {

          const apicall = iseditable ? this.restService.editOrganisation(modifypayloadvalues, this.editedAdmin.orgId) : this.restService.addOrganisation(modifypayloadvalues)
          apicall.subscribe({
            next: (value) => {
              if (value) {
                // const apicall = iseditable ? this.restService.editAdmins(payload, this.editedAdmin.id) : this.restService.addAdminDisturer(payload)
                this.notificationService.showNotification(iseditable ? 'admin distributer updated sucessfully' : 'admin distributor added successfully'
                )

                 if(value.type==='INSURER'){
                              this.memberService.emitRefreshInsurerOrg();

              }
              else if(value.type==='PROVIDER'){
                              this.memberService.emitRefreshProviderOrg();

              }
              else if(value.type==='DISTRIBUTOR'){
                              this.memberService.emitRefreshDistributorOrg()

              }
              
              this.dialogRef.close(true );
              this.dialogRef.close()
            } 
                this.dialogRef.close(true);
                this.memberService.emitRefreshInsurerOrg();

              
            },
            error: (err) => {
              console.log(err)
              this.notificationService.showNotification(err.error.error)
              this.dialogRef.close(true)
            }
          })
        }
        else if(!res){
          this.isSubmitLoading=false;
        }
        
        
      })
     }
    // }
  }

  closeDialog() {
    console.log(this.insurerForm)

    this.dialogRef.close();
  }

  // Method to validate date range
  validateDateRange(): boolean {
    const startDate = this.insurerForm.get('activeStartDate')?.value;
    const endDate = this.insurerForm.get('activeEndDate')?.value;

    if (endDate && startDate) {
      return new Date(endDate) > new Date(startDate);
    }
    return true;
  }

  getproviderOrg() {
    this.adminInsurerList = [];
    this.restService.getAllProviderOrganisations().subscribe({
      next: (values) => {
        this.adminInsurerList = values;
        console.log(values)
      },
      error: (err) => {
        console.log(err);
        this.notificationService.showNotification(err);
      }
    })
  }

   getInsurerOrg() {
    this.insurerorg = [];
    this.restService.getAllInsurerOrganisations().subscribe({
      next: (values) => {
        this.insurerorg = values;
        console.log(values)
      },
      error: (err) => {
        console.log(err);
        this.notificationService.showNotification(err);
      }
    })
  }

  getDistributorOrg(){

     this.insurerorg = [];
    this.restService.getAllDistributorOrganisations().subscribe({
      next: (values) => {
        this.insurerorg = values;
        console.log(values)
      },
      error: (err) => {
        console.log(err);
        this.notificationService.showNotification(err);
      }
    })
  }

  adminInsurerList: any[] = [];

  selectedProviderIds: string[] = [];

  selectProvider(user: any) {
    const index = this.selectedProviderIds.indexOf(user.id);
    if (index > -1) {
      // Already selected → deselect
      this.selectedProviderIds.splice(index, 1);
    } else {
      // Not selected → add
      this.selectedProviderIds.push(user.id);
    }
    this.insurerForm.patchValue({ mappedOrgIds: this.selectedProviderIds })
    console.log(this.selectedProviderIds)
  }


}
